import {
    Component,
    computed,
    effect,
    EventEmitter,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
    signal,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {ProyectoItem, ProyectoResponse, SolicitudEstadoEnum} from '../../../interfaces/proyecto.interface';
import {Router} from '@angular/router';
import {ProyectoService} from '../../services/proyecto.service';
import {Table} from 'primeng/table';
import {ConfirmationService, FilterMatchMode, MessageService, TreeNode} from 'primeng/api';
import {DatePipe} from '@angular/common';
import {RandomSessionIdService} from "../../../../guards/random-session-id.service";
import {LoginServices} from "../../../../auth/login/services/login.service";
import {ObtencionGenerica,} from '../ver-proyecto/interface/ver-proyecto.interface';
import Swal from 'sweetalert2';
import {SolicitudCancelarService} from '../../services/solicitud-cancelar.service';
import {SolicitudCancelarRequest} from '../../interfaces/solicitud-cancelar.interface';
import {FiltersService} from 'src/app/shared/services/filters-service';
import {ProyectoDataService} from "../../services/proyecto-data.service";
import {AsignacionesDataService} from 'src/app/officials/asignaciones/services/asignaciones-data.service';
import {RpService} from "../../../registro-profesionales/services/rp.service";
import {indexProyecto, norm} from "./lista-proyectos-index-util";
import {shareReplay, timer} from "rxjs";
import {map, startWith} from "rxjs/operators";

@Component({
    selector: 'lista-proyectos',
    templateUrl: './lista-proyectos.component.html',
    styleUrls: ['./lista-proyectos.component.css'],
    providers: [ConfirmationService, MessageService, DatePipe, SolicitudCancelarService]
})
export class ListaProyectosComponent implements OnInit, OnDestroy {
    @Input() ocultarBotonNuevo: boolean = true;
    @Input() mostrarFiltros: boolean = true;
    @Input() titulo: string = "Inmuebles"
    @Input() cardStyle: string | null | undefined = ""
    @Input() skipOnInit: boolean = false;
    @Input() confirmarAsignacionTemplate!: TemplateRef<any>;
    @Input() confirmarEditAsignacionTemplate!: TemplateRef<any>;
    @Input() initEvaluacion!: TemplateRef<any>;
    /**
     * local --> this.proyectos
     * pds --> this.proyectoDataService.itemsPorEstado()
     * rprof --> registroProf?
     */
    @Input() dataSource = "local";
    @Output() itemClickedEvaluacion = new EventEmitter<{ item: any, event: Event }>();
    sessionId: string | null
    rangoDeFechas: Date[] | undefined;
    consoleEnabled: boolean = false;
    carnetCargado: boolean = false;
    carnetDescargado: boolean = false;
    carnetExistente: boolean = false;
    carnetData: ObtencionGenerica = {};
    estadoValidoParaDescarga: string = "Aprobada";
    minCaracteres: number = 10;
    openObservaciones = signal(false);
    openConfirmacionCancelacion = signal(false);
    proyectoSeleccionado: ProyectoItem[] = [];
    selectedCount = computed(() => this.selectedProyectos().length);
    selectedProyectos = signal<ProyectoItem[]>([]);
    observaciones = signal('');
    isLoading = signal(false);
    estados = signal<string>('1,2,3,4,5,6,7,8,9,10,11,12,13');
    isLoadingPds = computed(() => this.pds.loading());
    visibleAsignacionRP: boolean = false;
    opcionesFiltroTramites: TreeNode[] = [
        {
            label: 'Todos',
            icon: 'pi pi-tags',
            key: 'todas',
            selectable: true,
        },
        {
            label: 'Con trámites',
            icon: 'pi pi-tags',
            key: 'ocultar',
            selectable: true,
        },
        {
            label: 'Sin trámites',
            icon: 'pi pi-tags',
            key: 'mostrar',
            selectable: true,
        }];
    selectedFiltroTramites: TreeNode | null = null;
    @ViewChild('calendar') private calendar: any;

    constructor(
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        public rs: RandomSessionIdService,
        public ls: LoginServices,
        private router: Router,
        private proyectoServices: ProyectoService,
        private datePipe: DatePipe,
        private solicitudCancelarService: SolicitudCancelarService,
        private filtersService: FiltersService,
        protected pds: ProyectoDataService,
        private asignacionesDataService: AsignacionesDataService,
        protected rpService: RpService,
        private zone: NgZone
    ) {
        this.sessionId = rs.randomSessionId();
    }

    ngOnInit() {
        this.filtersService.clearRange();
        this.filtersService.resetRangeToDefault();
        console.log(`ngOnInit() ->` + this.constructor.name)
        if (!this.skipOnInit) {
            if (this.dataSource == 'rprof') {
                this.pds.selectedId = this.estados();
                if (this.ls.isRolGerenteTecnico()) {
                    this.pds.consultarPorTipoDeSolicitud('3');
                } else if (this.ls.isRolCliente()) {
                    this.pds.consultarPorTipoDeSolicitud('3', true);
                }
            } else {
                this.consultarGeneralesProyecto();
            }
        }
    }

    observacionesTexto(texto: string) {
        this.observaciones.set(texto);
    }

    isAtencionCliente = computed(() => this.ls.hasRole('atencion.cliente'));
    //validacion para limpiar el editor con los tags html para validacion de caracteres
    observacionInvalida = computed(() => this.observaciones().trim().length < this.minCaracteres)

    confirmarCancelacion() {
        if (this.isLoading()) return;
        console.log('Observación:', this.observaciones);
        console.log('Seleccionados:', this.selectedProyectos());
        const seleccionados = this.selectedProyectos();
        const observacion = this.observaciones();
        if (this.observacionInvalida()) return;
        const usuario = this.ls.session()?.perfil?.usuario;
        const uniqueId = this.ls.session()?.perfil?.uniqueId;
        const payload: SolicitudCancelarRequest[] = seleccionados.map(proyecto => ({
            idProyecto: proyecto.idProyecto,
            idSolicitud: proyecto.idSolicitud,
            creadoPor: usuario,
            observaciones: observacion,
            estado: true,
            unique_id_usuario: uniqueId
        }));
        this.isLoading.set(true);
        this.solicitudCancelarService.cancelarSolicitud(payload).subscribe({
            next: (resp) => {
                Swal.fire({
                    icon: 'success',
                    title: 'Solicitud Cancelada',
                    text: 'Solicitud/es cancelada/s',
                    confirmButtonAriaLabel: 'Aceptar'
                })
                this.isLoading.set(false);
            },
            error: (err) => {
                console.log(err.error.mensaje);
                this.isLoading.set(false);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: err.error.mensaje,
                    confirmButtonAriaLabel: 'Aceptar'
                })
            },
            complete: () => {
                this.selectedProyectos.set([]);
                this.observaciones.set('');
                this.openObservaciones.set(false);
                this.isLoading.set(false);
                if (this.dataSource === 'pds' && (this.ls.isRolGerenteTecnico() || this.ls.isRolTecnicoResolutor())) {
                    this.pds.consultarPorTipoDeSolicitud('1,2')
                } else if (this.dataSource === 'rprof' && (this.ls.isRolJefeRegistro() || this.ls.isRolTecnicoRegistro() || this.ls.isRolGerenteTecnico())) {
                    this.pds.consultarPorTipoDeSolicitud('3')
                } else if (this.ls.isRolCliente() && this.dataSource === 'rprof') {
                    this.pds.consultarPorTipoDeSolicitud('3', true);
                } else {
                    this.consultarGeneralesProyecto();
                }
            }
        })
        this.observaciones.set('');
        this.selectedProyectos.set([]);
        this.openObservaciones.set(false);
    }

    puedeCancelar(): boolean {
        const seleccionados = this.selectedProyectos();
        if (!seleccionados || seleccionados.length === 0) return false;
        let estadosValidos = ['pendiente', 'evaluacion'];
        if (this.ls.isRolCliente()) {
            estadosValidos = ['pendiente'];
        }
        return seleccionados.every(p => {
            const estado = p.estadoSolicitud?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            return estadosValidos.includes(estado);
        });
    }

    //evaluar si se puede
    esSeleccionable(proyecto: ProyectoItem): boolean {
        const estado = proyecto.estadoSolicitud?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        let estadosSeleccionables = ['pendiente', 'evaluacion'];
        if (this.ls.isRolCliente()) {
            estadosSeleccionables = ['pendiente'];
        }
        return estadosSeleccionables.includes(estado);
    }

    esCancelada(proyecto: ProyectoItem): boolean {
        return proyecto.estadoSolicitud.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === 'cancelacion';
    }

    obtenerNombreEstado(estado: string | undefined): string {
        if (!estado) return '';
        const normalizado = estado.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return normalizado === 'cancelacion' ? 'Cancelada' : estado;
    }

    ejecutarCancelacion() {
        this.openConfirmacionCancelacion.set(false);
        this.confirmarCancelacion();
    }

    hiddeDialog() {
        this.openObservaciones.set(false);
    }

    toggleSeleccionarTodos(seleccionar: boolean) {
        const seleccionables = this.pds.itemsPorEstado().filter(p => this.esSeleccionable(p));
        this.selectedProyectos.set(seleccionar ? seleccionables : []);
    }

    estadosNombres = computed(() => {
        const proyectos = this.pds.itemsPorEstado();
        if (!proyectos || proyectos.length === 0) return [];
        const idsUnicos = [...new Set(proyectos.map(p => p.estadoSolicitud))];
        return idsUnicos.map(idEstadoSolicitud => ({
            value: idEstadoSolicitud,
            name: this.obtenerNombreEstado(idEstadoSolicitud)
        }));
    });

    todosSeleccionados(): boolean {
        const seleccionables = this.pds.itemsPorEstado().filter(prj => !this.esCancelada(prj));
        const seleccionados = this.selectedProyectos();
        return seleccionables.every(sel => seleccionados.includes(sel)) && seleccionados.length === seleccionables.length;
    }

    // isRegistroProfesional(proyecto: ProyectoItem): boolean {
    //     if (this.dataSource == 'rprof') {
    //         if (this.ls.isRolCliente()) {
    //             return false;
    //         }else if (this.ls.isBotonSelectedValido()) {
    //             return true;
    //         }
    //     }else {
    //         if (this.ls.isBotonSelectedValido()) {
    //             return true;
    //         }
    //     }
    //     return false;
    //     // return proyecto.nombre.startsWith('RP_') || false;
    // }
    isRegistroProfesional(proyecto: ProyectoItem): boolean {
        // en rprof el cliente_ventanilla no puede habilitar
        if (this.dataSource === 'rprof') {
            return false;
        }

        return this.ls.isBotonSelectedValido();
    }

    isRolCliente = computed(() => {
        return this.ls.hasRoles(['cliente_ventanilla'])
    });
    isRolFuncionario = computed(() => {
        return this.ls.hasRoles(['ministro', 'gerente', 'jefe', 'tecnico_resolutor', 'atencion.cliente'])
    });

    consultaPorFechas() {
        console.log(`this.consultaPorFechas:${this.rangoDeFechas}`);
        if (this.ls.isRolGerenteTecnico() || this.ls.isRolTecnicoResolutor()) {
            this.pds.consultarPorTipoDeSolicitud('1,2')
        } else if (this.ls.isRolJefeRegistro() || this.ls.isRolTecnicoRegistro()) {
            this.pds.consultarPorTipoDeSolicitud('3')
        } else if (this.ls.isRolCliente()) {
            this.pds.consultarPorTipoDeSolicitud('1,2')
        } else {
            this.pds.consultarPorTipoDeSolicitud('1,2,3')
        }
    }

    @Output() itemClicked = new EventEmitter<{ item: any, event: Event, operationType: number }>();

    onItemClicked(item: ProyectoResponse, operationType: number, event: Event) {
        this.itemClicked.emit({item, event, operationType});
    }

    onItemClickedEvaluacion(item: ProyectoResponse, event: Event) {
        this.itemClickedEvaluacion.emit({item, event});
    }

    consultarGeneralesProyecto() {
        this.proyectoServices.getGeneralesProyecto(this.ls.session()?.perfil.usuario)
            .subscribe({
                next: (result) => {
                    this.pds.itemsPorEstado.set(result.body!)
                    this.pds.itemsPivot.set(result.body!)
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }

    aplicarFiltroTramites() {
        console.log(`selectedFiltroTramites:${JSON.stringify(this.selectedFiltroTramites)}`);
        console.log(`dataSource:${JSON.stringify(this.dataSource)}`);
        //TODO: Agregar soporte por DS?
        // if (this.dataSource === 'local') {
        //     this.consultarGeneralesProyecto()
        // } else if (this.dataSource === 'pds') {
        // }
        this.pds.itemsPorEstado.set(this.pds.itemsPivot())
        let filteredItems = [];
        if (this.pds.itemsPorEstado() && this.pds.itemsPorEstado().length > 0) {
            console.log(`proyectos:${this.pds.itemsPorEstado().length}`);
            if (this.selectedFiltroTramites?.key === 'ocultar') {
                filteredItems = this.pds.itemsPorEstado().filter(p => p.cantidadTramites > 0)
                this.pds.itemsPorEstado.set(filteredItems)
            } else if (this.selectedFiltroTramites?.key === 'mostrar') {
                filteredItems = this.pds.itemsPorEstado().filter(p => p.cantidadTramites === 0);
                this.pds.itemsPorEstado.set(filteredItems)
            } else if (this.selectedFiltroTramites?.key === 'todas') {
                this.consultarGeneralesProyecto();
            }
            console.log(`filtered:${filteredItems.length}`);
        } else {
            console.log(`No hay items disponibles para aplicar filtros`);
            return
        }
    }

    readonly effectFiltroRango = effect(() => {
        const rango = this.filtersService.selectedRangeSignal();
        if (this.filtersService.usuarioSeleccionoRango && rango.length === 2) {
            if (this.ls.isRolCliente() && this.dataSource == 'rprof') {
                this.pds.selectedId = this.estados();
                this.pds.consultarPorTipoDeSolicitud('3', true);
            } else if (this.ls.isRolGerenteTecnico() && this.dataSource == 'rprof') {
                this.pds.selectedId = this.estados();
                this.pds.consultarPorTipoDeSolicitud('3', false);
            } else if (this.ls.isRolGerenteTecnico() && this.dataSource == 'pds') {
                this.pds.consultarPorTipoDeSolicitud('1,2');
            } else if (this.ls.isRolTecnicoResolutor() && this.dataSource == 'pds') {
                this.pds.consultarPorTipoDeSolicitud('1,2,3', true);
            } else {
                this.pds.selectedId = this.estados();
                this.pds.consultarPorTipoDeSolicitud('1,2', true);
            }
        }
    }, {allowSignalWrites: true});

    onFiltroTramitesChange() {
        console.log(`onFiltroTramitesChange()`)
        this.aplicarFiltroTramites();
    }

    openAsignacionRP(proyectos: any[]) {
        this.visibleAsignacionRP = true;
    }

    ngOnDestroy(): void {
        this.filtersService.clearRange();
        this.filtersService.resetRangeToDefault();
    }

    protected readonly Array = Array;
    rows = computed(() => {
        const src = this.pds.itemsPorEstado() ?? [];
        return src.map(p => ({...p, _search: indexProyecto(p)}));
    });
    filteredRows = computed(() => {
        const q = this.globalQ().trim();
        const data = this.rows();
        if (!q) return data;
        const esc = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const tokens = q.split(/\s+/).filter(Boolean);
        const re = new RegExp(tokens.map(esc).join('.*'), 'i');
        return data.filter(r => re.test(r._search));
    });
    globalQ = signal<string>('');

    onGlobalInput(q: string, dt: Table) {
        const nq = norm(q).trim();
        this.globalQ.set(nq);
        dt.filterGlobal(nq, FilterMatchMode.CONTAINS);
    }

    clear(table: Table) {
        table.clear();
        this.globalQ.set('');
        this.pds.itemsPorEstado.set([]);
        this.rangoDeFechas = [];
        this.selectedFiltroTramites = null;
        this.filtersService.resetRangeToDefault();
        if (this.dataSource == 'rprof') {
            if (this.ls.isRolGerenteTecnico()) {
                this.pds.consultarPorTipoDeSolicitud('3');
            } else if (this.ls.isRolCliente()) {
                this.pds.consultarPorTipoDeSolicitud('3', true);
            }
        } else if (this.dataSource == 'pds') {
            if (this.ls.isRolGerenteTecnico()) {
                this.pds.consultarPorTipoDeSolicitud('1,2');
            } else if (this.ls.isRolTecnico()) {
                this.pds.consultarAsignadosPorUsuarioSession();
            }
        } else {
            this.consultarGeneralesProyecto();
        }
    }

    readonly now$ = this.zone.runOutsideAngular(() =>
        timer(this.msToNextMidnight(), 86_400_000)
    ).pipe(startWith(0), map(() => Date.now()), shareReplay({bufferSize: 1, refCount: true}));

    private msToNextMidnight() {
        const n = new Date();
        const m = new Date(n);
        m.setHours(24, 0, 0, 0);
        return +m - +n;
    }

    /**Metodo que valida el estado del boton  para realizar observaciones si existe evaluaciones
     * debe de existir almenos una evaluacion iniciada para poder realizar el proceso de evaluacion
     * 11-Evaluacion
     * 6-Observada
     * 5-Visita aprobada
     * 8-Resolucion tecnica
     * 3-EnProceso
     * 7-Corregida*/
    validadStatusEval(idSolicitudEstado: number): boolean {
        const estadosPermitidos = [SolicitudEstadoEnum.Evaluacion, SolicitudEstadoEnum.Observada, SolicitudEstadoEnum.VisitaAprobada, SolicitudEstadoEnum.ResolucionTecnica
            ,SolicitudEstadoEnum.EnProceso, SolicitudEstadoEnum.Corregida];
        return estadosPermitidos.includes(idSolicitudEstado);
    }

}
